export default __webpack_public_path__ + "static/media/investment.0e79f0ca.svg";